export default function Content3Icon() {
  return (
    <svg
      width="127"
      height="102"
      viewBox="0 0 127 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M57.4198 100.992C82.8838 100.992 103.553 80.5173 103.553 55.2686C103.553 30.02 82.8838 9.54523 57.4198 9.54523C31.9559 9.54523 11.2864 30.02 11.2864 55.2686C11.2864 80.5173 31.9559 100.992 57.4198 100.992Z"
        fill="#F1F3FA"
        stroke="#D6DDE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M5.74559 49.7521C7.45028 49.7521 8.83535 48.4791 8.83535 46.6756C8.83535 44.8721 7.45028 43.5991 5.74559 43.5991C4.04089 43.5991 2.65582 44.8721 2.65582 46.6756C2.65582 48.4791 4.14743 49.7521 5.74559 49.7521Z"
        fill="#F1F3FA"
      />
      <path
        d="M2.7628 39.9921C3.93478 39.9921 4.78713 39.0373 4.78713 37.8704C4.78713 36.8095 3.82824 35.7486 2.7628 35.7486C1.69737 35.7486 0.738472 36.7034 0.738472 37.8704C0.525385 39.1434 1.48428 39.9921 2.7628 39.9921Z"
        fill="#F1F3FA"
      />
      <path
        d="M112.397 57.3904C114.527 57.3904 116.339 55.693 116.339 53.4652C116.339 51.2374 114.634 49.54 112.397 49.54C110.266 49.54 108.454 51.2374 108.454 53.4652C108.561 55.693 110.266 57.3904 112.397 57.3904Z"
        fill="#F1F3FA"
      />
      <path
        d="M99.3979 87.8374H16.0807C12.6713 87.8374 9.90118 85.0792 9.90118 81.6844V31.081C9.90118 27.6863 12.6713 24.928 16.0807 24.928H99.2913C102.701 24.928 105.471 27.6863 105.471 31.081V81.6844C105.577 85.0792 102.807 87.8374 99.3979 87.8374Z"
        fill="white"
        stroke="#D6DDE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M16.0812 41.3715V33.0968C16.0812 31.8237 17.0401 30.8689 18.3187 30.8689H97.2675C98.546 30.8689 99.5049 31.8237 99.5049 33.0968V79.5627C99.5049 80.8358 98.546 81.7906 97.2675 81.7906H18.3187C17.0401 81.7906 16.0812 80.8358 16.0812 79.5627V59.4063"
        fill="white"
      />
      <path
        d="M16.0812 41.3715V33.0968C16.0812 31.8237 17.0401 30.8689 18.3187 30.8689H97.2675C98.546 30.8689 99.5049 31.8237 99.5049 33.0968V79.5627C99.5049 80.8358 98.546 81.7906 97.2675 81.7906H18.3187C17.0401 81.7906 16.0812 80.8358 16.0812 79.5627V59.4063"
        stroke="#D6DDE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M16.0812 54.6323V48.161"
        stroke="#D6DDE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M95.2566 23.0292C95.3505 23.1227 95.4443 23.1227 95.5382 23.1227C96.1013 23.3096 96.7583 22.9358 96.946 22.2816C99.48 16.1139 104.454 7.79687 111.493 4.52612L113.464 7.70342C113.746 8.17067 114.403 8.26412 114.966 7.79687C115.435 7.42307 115.623 6.67547 115.341 6.20822L113.37 3.03092C112.901 2.28333 112.056 2.09643 111.212 2.47023C102.483 5.92787 97.7906 15.086 95.0689 21.7209C94.7874 22.2816 94.8812 22.7489 95.2566 23.0292Z"
        fill="#AAB2C5"
      />
      <path
        d="M77.2371 61.1568C77.8941 61.7175 78.2695 61.9978 78.3633 62.0913C78.3633 62.0913 78.3633 62.0913 79.6773 63.1192C81.8359 60.5961 86.7162 59.3812 89.7195 59.6616C89.6256 59.6616 91.5965 54.148 91.8781 53.6808C93.5674 50.5969 95.9138 47.8869 98.0724 45.1768L92.7228 43.1209L95.8199 39.2895L92.6289 43.1209L90.0949 39.1026C88.124 41.6257 86.3408 44.2423 84.0883 46.4851C82.3051 48.2607 80.1465 49.569 77.9879 50.7838C79.1142 53.4004 79.1142 58.4467 77.2371 61.1568Z"
        fill="#D6DCE8"
        stroke="#AAB2C5"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M87.5691 53.235C88.0395 52.4931 87.8167 51.512 87.0716 51.0436C86.3265 50.5753 85.3412 50.797 84.8708 51.539C84.4004 52.2809 84.6232 53.262 85.3683 53.7303C86.1134 54.1987 87.0987 53.9769 87.5691 53.235Z"
        fill="#D6DCE8"
        stroke="#AAB2C5"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M78.3633 62.0914L85.1206 53.5875"
        stroke="#AAB2C5"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M124.257 1.25534C124.539 1.34879 124.633 1.44224 124.82 1.62914C127.636 4.33919 121.348 15.927 111.869 28.4493C104.454 38.1681 99.0109 44.6161 96.8523 46.9524C96.2891 47.5131 95.4445 47.6065 94.6936 47.2327C92.0658 45.6441 91.5965 45.1768 88.7809 42.6537C88.2178 42.093 88.124 41.1585 88.4994 40.5043C90.0949 37.7943 94.7875 30.879 102.014 21.0667C111.399 8.54444 120.972 -0.707105 124.257 1.25534Z"
        fill="white"
        stroke="#AAB2C5"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M122.286 12.7497C120.785 12.5628 116.467 10.5069 114.309 6.76886L122.286 12.7497Z"
        fill="white"
      />
      <path
        d="M122.286 12.7497C120.785 12.5628 116.467 10.5069 114.309 6.76886"
        stroke="#AAB2C5"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M23.3257 72.561C30.038 70.121 35.7914 64.9228 38.7746 58.4515C37.7091 61.528 35.1521 70.6515 38.0288 72.4549C39.0942 73.1976 40.6924 72.8793 41.6513 72.0306C42.9298 70.9697 42.9298 70.9697 52.0925 53.1472C50.9205 55.375 50.1747 56.8602 49.4289 59.3002C48.6831 61.7402 47.8308 64.9228 48.0439 67.4689C48.257 71.1819 49.642 72.561 51.1336 72.9854C55.1823 74.1523 56.7804 68.9541 57.2066 66.0897C56.7804 67.2567 56.7804 67.9993 56.6739 69.2723C56.4608 74.5767 61.2553 74.6828 63.1731 72.9854C65.0909 71.1819 65.517 69.8028 65.8367 68.6358C65.517 69.8028 65.1974 70.5454 65.3039 71.7123C65.6236 74.0462 69.033 74.8949 70.8442 71.3941"
        stroke="#AAB2C5"
        stroke-width="4"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M74.5732 66.8324V66.7263"
        stroke="#AAB2C5"
        stroke-width="4"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
